import React, { useEffect, useRef, useState } from 'react';
import "./exploretoptalent.scss"
import VerifiedIcon from '@mui/icons-material/Verified';
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link, useNavigate } from 'react-router-dom';
import { axiosApi } from '../../../../_helper/api_helper';



const ExploreTopTalent = () => {
    const history = useNavigate()

    const carouselRef = useRef(null);
    const [freelancersData, setFreelancersData] = useState([])
    const [activeButton, setActiveButton] = useState(null);
    const [IndustriesData, setIndustriesData] = useState([]);
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [error, setError] = useState(null);


    useEffect(() => {
        IndustriesGet();

    }, []);
    const IndustriesGet = async () => {
        const response = await axiosApi.get("/industries");
        setIndustriesData(response?.data)
    }
    useEffect(() => {
        if (selectedSkills.length === 0) {
            setFreelancersData([]);
            return;
        }


        const encodedSkills = encodeURIComponent(selectedSkills);

        const fetchFilteredData = async () => {
            try {
                const response = await axiosApi.get(`/clients/filter?Occupation_industry=${encodedSkills}`);
                setFreelancersData(response?.data);
                setError(null);
            } catch (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    setError(err.response.data.error);
                } else {
                    setError('An error occurred while fetching data.');
                }
                setFreelancersData([]);
            }
        };

        fetchFilteredData();
    }, [selectedSkills]);
    useEffect(() => {
        axiosApi.get('/freelancer/all').then((response) => {
            setFreelancersData(response?.data)
        })
    }, []);

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
        setActiveButton('left');
    }

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
        setActiveButton('right');
    }
    const handleSkillChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedSkills(selectedValue);
    }
    const handleNavigateFreelancer = (navId) => {
        history(`/Freelancer/${navId}`)
    }

    return (
        <>
            <div className="explore-toptalent-home-container">
                <div className="explore-toptalent-home">

                    <div className="home-explore-top">
                        <div className="explore-job-inner">
                            <div className="explore-top-job-heading">
                                <h3>Explore Top Talents</h3>
                                <p>Hire Freelancers-Find the Talent Fit for Your Project Needs!</p>
                            </div>
                            <div className="explore-top-job-heading explore-top-job-view">
                                <Link to={'/all-freelancer'}><button> View All <EastIcon className='explore-easr-icon' /></button></Link>
                            </div>
                        </div>

                        <div className="home-exploret-top-inner">
                            <div className="blog-inner-first">

                                <select class="form-select" onChange={handleSkillChange} aria-label="Default select example">
                                    <option selected>Select Category</option>
                                    {IndustriesData.map((item) => (
                                        <option key={item.id} value={item.name}>{item?.name}</option>

                                    ))}

                                </select>
                            </div>
                            <div className="blog-inner-second">

                                <div className="inner-button-carousel" >
                                    <button className={`carousel-button left ${activeButton === 'left' ? 'active' : ''}`} onClick={scrollLeft}><WestIcon className='icon-left' /></button>
                                    <button className={`carousel-button right ${activeButton === 'right' ? 'active' : ''}`} onClick={scrollRight}><EastIcon className='icon-left' /></button>
                                </div>


                            </div>
                        </div>
                    </div>


                    <div className="slick-carousel-explore-top-talent" >
                        <div className="slick-container">
                            {freelancersData?.length > 0 &&
                                <div>
                                    <Carousel
                                        ref={carouselRef}
                                        additionalTransfrom={0}
                                        arrows={false}
                                        autoPlaySpeed={3000}
                                        centerMode={false}
                                        className=""
                                        containerClass="carousel-container"
                                        customButtonGroup={<button></button>}
                                        dotListClass=""
                                        draggable
                                        focusOnSelect={false}
                                        infinite
                                        itemClass=""
                                        keyBoardControl
                                        minimumTouchDrag={80}
                                        renderButtonGroupOutside={false}
                                        renderDotsOutside={false}
                                        responsive={{
                                            desktop: {
                                                breakpoint: {
                                                    max: 3000,
                                                    min: 1024
                                                },
                                                items: 3
                                            },
                                            mobile: {
                                                breakpoint: {
                                                    max: 464,
                                                    min: 0
                                                },
                                                items: 1
                                            },
                                            tablet: {
                                                breakpoint: {
                                                    max: 1024,
                                                    min: 464
                                                },
                                                items: 2
                                            }
                                        }}
                                        showDots={false}
                                        sliderClass=""
                                        slidesToSlide={1}
                                        swipeable
                                    >
                                        {freelancersData.map((item, index) => (

                                            <div className="explore-top-talent-applicant-card" key={item.id}>
                                                <div className="explore-top-talent-applicant-card-inner">
                                                    <div className="applicant-profile">
                                                        <div className="applicant-img">
                                                            <img src={`${axiosApi?.defaults?.baseURL}${item?.profile_pic}`} alt="" />
                                                        </div>
                                                        <div className="applicant-content">
                                                            <div className="recuiter-freelance-name">
                                                                <h5>{item?.name}</h5>
                                                                <h5>
                                                                    {item?.trusted_shield == true && <span style={{ color: "red", fontWeight: "500" }} className='ms-2'><img src="/svg/trustshieldnew.svg" width={'23'} height={'23'} alt="" />Trusted Shield</span>}

                                                                </h5>
                                                                {item?.verified == true && <span><VerifiedIcon className='explore-verified-icon' style={{ color: '#ffffff' }} /> Verified</span>}

                                                            </div>
                                                            <div className="recuiter-freelance-category">
                                                                <h6>{item?.Occupation_industry}
                                                                    {/* <span> {item?.gender === "MALE" ? (
                                                                        <img src="/svg/male.svg" width='15px' alt="" />
                                                                    ) : item?.gender === "FEMALE" ? (
                                                                        <img src="/svg/female.svg" width='15px' alt="" />
                                                                    ) : (
                                                                        <img src="/svg/transgender.svg" width='15px' alt="" />
                                                                    )}</span> */}
                                                                </h6>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="applicant-education">
                                                        <div className="applicant-education-name"><img src="/svg/location.svg" alt="" />
                                                            {/* {item?.city_new} */}
                                                            {item?.city_new?.split(' ').length > 8
                                                                ? item.city_new.split(' ').slice(0, 8).join(' ') + '..'
                                                                : item.city_new}
                                                        </div>
                                                       <div className="applicant-education-name"><img src="/svg/bag.svg" alt="" /> {item?.experience_txt || item?.freelancer_experience}</div>

                                                        <div className="applicant-education-name"><img src="/svg/rupee.svg" alt="" /> {item?.project_price} /hour</div>
                                                    </div>
                                                    <div className="applicant-button">
                                                        <button onClick={() => handleNavigateFreelancer(item?.id)}>View Profile</button>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Carousel>
                                </div>
                            }
                        </div>


                    </div>
                </div>
            </div>


        </>
    )
}


export default ExploreTopTalent;




// const calculateTimeElapsed = (createdAt) => {
//     const currentDate = new Date();
//     const postedDate = new Date(createdAt);
//     const timeDifference = currentDate - postedDate;

//     const seconds = Math.floor(timeDifference / 1000);
//     const minutes = Math.floor(seconds / 60);
//     const hours = Math.floor(minutes / 60);
//     const days = Math.floor(hours / 24);
//     const weeks = Math.floor(days / 7);
//     const months = Math.floor(days / 30);
//     const years = Math.floor(days / 365);

//     if (years > 0) {
//         return `${years} ${years === 1 ? 'year' : 'years'} ago`;
//     } else if (months > 0) {
//         return `${months} ${months === 1 ? 'month' : 'months'} ago`;
//     } else if (weeks > 0) {
//         return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
//     } else if (days > 0) {
//         return `${days} ${days === 1 ? 'day' : 'days'} ago`;
//     } else if (hours > 0) {
//         return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
//     } else if (minutes > 0) {
//         return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
//     } else {
//         return `${seconds} ${seconds === 1 ? 'second' : 'seconds'} ago`;
//     }
// };
